import CircleWarningIcon from '@ping/assets/Icon/circle-warning.svg';
import { modalKeys } from '@ping/constants/modal-keys.constant';
import { t } from '@ping/helpers';
import { useRemoteModal } from '@ping/hooks';
import { Button, Modal } from '@ping/uikit';

import style from './style.module.scss';

export const ReceivedDataModal = () => {
  const modal = useRemoteModal(modalKeys.RECEIVED_USER_DATA);

  return (
    <Modal.Root {...modal.props}>
      <Modal.Portal className={style['received-data-modal']}>
        <Modal.Header className={style['received-data-modal__header']}>
          <CircleWarningIcon className={style['received-data-modal__icon']} />
        </Modal.Header>

        <Modal.Content className={style['received-data-modal__content']}>
          <Modal.Title className={style['received-data-modal__title']}>{t('We have received your data')}</Modal.Title>
          <p className={style['received-data-modal__description']}>
            {t(
              'Before we continue, Ping Exchange is required by law to request your signature to approve encryption and storage of your data in order to comply with the EU’s General Data Protection Regulation (GDPR) and other data protection regulations (CPA, CCPA).'
            )}
          </p>
        </Modal.Content>
        <Modal.Actions className={style['received-data-modal__btn']}>
          <Button size='extra-large' onClick={modal.state.close} uppercase>
            {t('Continue')}
          </Button>
        </Modal.Actions>
      </Modal.Portal>
    </Modal.Root>
  );
};
